import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../helpers/axiosInstance";
import { toast } from "react-toastify";

const initialState = {
    auditLogsData: [],
    pagination: null,
    loading: false,
    error: null,
};

export const getAllAuditLogs = createAsyncThunk(
    "audit-logs/get-all-audit-logs",
    async ({ user, search }) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const base = url?.backoffice;
            const endpointpath = endpoint?.backoffice?.ActivityLogs;

            const apiURL = base + endpointpath;

            const response = await axiosInstance.post(apiURL, search);

            if(response?.data?.responseCode === '404') {
                toast.error(response?.data?.responseDescription);
            }
            if(response?.data?.resp && !Array.isArray(response?.data?.resp)) {
                toast.error(response?.data?.resp);
            }

            return response?.data;
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

const auditLogsSlice = createSlice({
    name: "audit-logs",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // GET ALL AUDIT LOGS
            .addCase(getAllAuditLogs.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllAuditLogs.fulfilled, (state, action) => {
                const { resp, currentPage, pageSize, totalItem, totalPages } = action?.payload;
                state.loading = false;
                state.auditLogsData = resp || [];
                state.pagination = {
                    currentPage: currentPage || 0,
                    pageSize: pageSize || 30,
                    totalItem,
                    totalPages
                };
            })
            .addCase(getAllAuditLogs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default auditLogsSlice.reducer;